import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';

import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import MyTable from '../../utils/MyTable';

import { headerSearch, tabs, unoTheme } from '../../../assets/styles/unoTheme';

//Utils
import {
    applyMaskAmount,
    applyMaskAmountFreeDecimals,
    getFirstDayMonth,
    getLastDayInMonthByMonthAndYear,
    getMonthsUntilPortfolioInit,
    getMonthsByArray,
    getDayMonthYearByStringDate,
    getFirstPtDayOfYear,
    getLastPtDayMonth
} from "../../utils/utils";
import MySelect from '../../utils/MySelect';
import MyAutoComplete from '../../utils/MyAutoComplete';

import { MyTab, MyTabs } from "../../utils/MyTabs";

import { TableFooter, Tooltip } from "@material-ui/core";

import UnoButton from '../../utils/UnoButton';

//Api

//redux
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../../actions';

import moment from 'moment';
import { getAnaliticTitlesByPeriod, getDueDateTitle } from "../../../controllers/TitleController";
import { MARKING_MARKET, getWeightedMarkingAverage } from "../../utils/paramsToTitles";
import _ from 'lodash';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import XLSX from 'xlsx';
import { downloadBlob, s2ab } from "../../../controllers/ExcelController";
import PrintIcon from '@material-ui/icons/Print';
import { Pie } from 'react-chartjs-2';
import MyInnerLoad from '../../utils/MyInnerLoad';
import { getRegimeLabel, getRegimeOptions, parseRegimeValue, REGIME_SHEET_LABELS } from '../../utils/accountRegimes';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 14,
    },
    arrow: {
        color: theme.palette.common.white,
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: 'red',
    },
    iconButton: {
        padding: '5px',
    },
    headerSearch: {
        ...headerSearch,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'nowrap',
    },
    inputSearch: {
        width: "300px",
        background: "white"
    },

    tabs: tabs,

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '100px !important',
            width: 'auto',
        }
    },

    leftHeader: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
    },

    rightHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },

    filterContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginLeft: '20px'
    },

    smallTextsCells: {
        '& .MuiTableCell-root ': {
            fontSize: '0.9em',
        }
    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
            textWrap: 'nowrap'
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            whiteSpace: 'nowrap'
        }
    },

    distributionMain: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
        maxHeight: '100%',
        width: '100%',
        backgroundColor: 'white',
        borderRadius: '10px 0px 0px 10px',
    },

    distDivTable: {
        width: '60%',
        maxWidth: '60%',
        height: '100%',
    },

    distDivChart: {
        width: '40%',
        maxWidth: '40%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '16px',
    },

    distLegendTable: {
        width: '24px',
        height: '20px',
        borderRadius: '3px',
    },

    distTableFooter: {
        cursor: 'pointer',
        borderBottom: 'unset',
        '& > *': { borderBottom: 'unset' },
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },
        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },
        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },
    },

}));

export default function TitlesAnalyticScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const clientOn = useSelector(state => state.clientOn)
    const [tabValue, setTabValue] = React.useState(0);

    //titles 
    const [allTitles, setAllTitles] = React.useState(null);
    const [titlesToShow, setTitlesToShow] = React.useState(null);
    const [totals, setTotals] = React.useState(null);
    const [totalsBySector, setTotalsBySector] = React.useState(null);

    const [periodType, setPeriodType] = useState('month');
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [selectedQuarter, setSelectedQuarter] = useState(1);
    const [selectedSemester, setSelectedSemester] = useState(1);
    const [portfolioMonths, setPortfolioMonths] = useState([]);
    const [portfolioYears, setPortfolioYears] = useState([]);
    const [formattedPortfolioData, setFormattedPortfolioData] = useState({ months: {}, years: [] });

    const [orderBy, setOrderBy] = useState("due_date"); //coluna
    const [order, setOrder] = useState("desc")    // direção
    const [distOrderBy, setDistOrderBy] = useState("percent");
    const [distOrder, setDistOrder] = useState("desc");
    const [selectedTitleFilter, setSelectedTitleFilter] = useState(null);
    const [segregationSelected, setSegregationSelected] = useState(0);

    const accountRegimeId = parseRegimeValue(segregationSelected);

    const segregationsOptions = useMemo(
        () => getRegimeOptions(clientOn, { includeConsolidated: true }),
        [clientOn]);

    //Identifica a carga mais recente: respostas de seleções anteriores (período/segregação) são descartadas
    const loadRequestRef = useRef(0);
    const [flagDoExcelTitles, setFlagDoExcelTitles] = React.useState(false);
    function resetFlag() {
        setFlagDoExcelTitles(false);
    }

    const currentTabTotal = useMemo(() => totalsBySector ? tabValue === 1 ? totalsBySector.totalsPrivate : totalsBySector.totalsPublic : undefined, [tabValue, totalsBySector]);

    const sectorMarkingAverage = useMemo(() => getWeightedMarkingAverage(titlesToShow), [titlesToShow]);
    const globalMarkingAverage = useMemo(() => getWeightedMarkingAverage(allTitles), [allTitles]);
    const formatMarkingAverage = useCallback((avg) => (avg != null ? applyMaskAmount(avg) + "%" : "-"), []);

    const handleChangeTabValue = (event, newValue) => {

        setTabValue(newValue);
        if (newValue == 1) {
            setTitlesToShow(allTitles?.filter(el => el.sector != 'PUBLICO'))
        } else {
            setTitlesToShow(allTitles?.filter(el => el.sector == 'PUBLICO'))
        }

    };

    const initializePortfolioMonthsAndYears = useCallback((client) => {
        if (client && client.portfolio_init) {
            const portfolioData = getMonthsUntilPortfolioInit(
                client.portfolio_init,
                client.portfolio_closed || new Date()
            );

            setFormattedPortfolioData(portfolioData);
            setPortfolioYears(portfolioData.years || []);

            const currentYear = portfolioData.years ? portfolioData.years[portfolioData.years.length - 1] : new Date().getFullYear();
            setSelectedYear(currentYear);

            if (portfolioData.months && portfolioData.months[currentYear]) {
                const monthsArray = getMonthsByArray(portfolioData.months[currentYear]);
                setPortfolioMonths(monthsArray);

                if (monthsArray.length > 0) {
                    setSelectedMonth(monthsArray[monthsArray.length - 1].id);
                }
            }
        }
    }, []);

    const availableQuarters = useMemo(() => {
        if (!portfolioMonths.length || periodType !== 'quarter') return [];

        const quarters = [];
        const monthIds = portfolioMonths.map(m => m.id);

        for (let quarter = 1; quarter <= 4; quarter++) {
            const startMonth = (quarter - 1) * 3 + 1;
            const endMonth = startMonth + 2;

            const hasAllMonths = [startMonth, startMonth + 1, endMonth]
                .every(month => monthIds.includes(month));

            if (hasAllMonths) {
                quarters.push(quarter);
            }
        }

        return quarters;
    }, [portfolioMonths, periodType, selectedYear]);

    const availableSemesters = useMemo(() => {
        if (!portfolioMonths.length || periodType !== 'semester') return [];

        const semesters = [];
        const monthIds = portfolioMonths.map(m => m.id);

        for (let semester = 1; semester <= 2; semester++) {
            const startMonth = (semester - 1) * 6 + 1;
            const endMonth = startMonth + 5;

            const hasAllMonths = [startMonth, startMonth + 1, startMonth + 2,
                startMonth + 3, startMonth + 4, endMonth]
                .every(month => monthIds.includes(month));

            if (hasAllMonths) {
                semesters.push(semester);
            }
        }

        return semesters;
    }, [portfolioMonths, periodType, selectedYear]);

    useEffect(() => {
        if (selectedYear && formattedPortfolioData.months && formattedPortfolioData.months[selectedYear]) {
            const monthsArray = getMonthsByArray(formattedPortfolioData.months[selectedYear]);
            setPortfolioMonths(monthsArray);

            if (monthsArray.length > 0 && (!selectedMonth || !monthsArray.some(m => m.id === selectedMonth))) {
                setSelectedMonth(monthsArray[monthsArray.length - 1].id);
            }
        }
    }, [selectedYear, formattedPortfolioData]);

    useEffect(() => {
        if (periodType === 'quarter') {
            if (availableQuarters.length > 0) {
                if (!availableQuarters.includes(selectedQuarter)) {
                    setSelectedQuarter(availableQuarters[availableQuarters.length - 1]); // último válido
                }
            } else {
                setSelectedQuarter(null); // não existe trimestre válido
            }
        }

        if (periodType === 'semester') {
            if (availableSemesters.length > 0) {
                if (!availableSemesters.includes(selectedSemester)) {
                    setSelectedSemester(availableSemesters[availableSemesters.length - 1]); // último válido
                }
            } else {
                setSelectedSemester(null); // não existe semestre válido
            }
        }
    }, [availableQuarters, availableSemesters, periodType]);

    const getPeriodDates = useCallback(() => {
        let startDate, endDate, displayMonth, displayYear;

        const fallbackYear = formattedPortfolioData.years.length > 0
            ? formattedPortfolioData.years[formattedPortfolioData.years.length - 1]
            : new Date().getFullYear();

        const yearToUse = (selectedYear && formattedPortfolioData.years.includes(selectedYear))
            ? selectedYear
            : fallbackYear;

        const monthsForYear = formattedPortfolioData.months?.[yearToUse] || [];
        const fallbackMonth = monthsForYear.length > 0 ? monthsForYear[monthsForYear.length - 1] : 12;

        const monthToUse = (selectedMonth && monthsForYear.includes(selectedMonth))
            ? selectedMonth
            : fallbackMonth;

        switch (periodType) {
            case 'month':
                startDate = getFirstDayMonth(monthToUse, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(monthToUse, yearToUse);
                displayMonth = monthToUse;
                displayYear = yearToUse;
                break;
            case 'quarter': {
                let validQuarter = selectedQuarter;
                if (!validQuarter || !availableQuarters.includes(validQuarter)) {
                    validQuarter = availableQuarters.length > 0 ? availableQuarters[availableQuarters.length - 1] : 1;
                }
                const quarterStartMonth = (validQuarter - 1) * 3 + 1;
                const quarterEndMonth = quarterStartMonth + 2;
                startDate = getFirstDayMonth(quarterStartMonth, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(quarterEndMonth, yearToUse);
                displayMonth = quarterStartMonth;
                displayYear = yearToUse;
                break;
            }
            case 'semester': {
                let validSemester = selectedSemester;
                if (!validSemester || !availableSemesters.includes(validSemester)) {
                    validSemester = availableSemesters.length > 0 ? availableSemesters[availableSemesters.length - 1] : 1;
                }
                const semesterStartMonth = (validSemester - 1) * 6 + 1;
                const semesterEndMonth = semesterStartMonth + 5;
                startDate = getFirstDayMonth(semesterStartMonth, yearToUse);
                endDate = getLastDayInMonthByMonthAndYear(semesterEndMonth, yearToUse);
                displayMonth = semesterStartMonth;
                displayYear = yearToUse;
                break;
            }
            case 'year':
                startDate = getFirstPtDayOfYear(yearToUse);
                endDate = getLastPtDayMonth(monthToUse, yearToUse);
                displayMonth = monthToUse;
                displayYear = yearToUse;
                break;
        }

        return { startDate, endDate, displayMonth, displayYear };

    }, [periodType,
        selectedMonth,
        selectedYear,
        selectedQuarter,
        selectedSemester,
        availableQuarters,
        availableSemesters,
        formattedPortfolioData]);

    async function loadTitles(client, regimeId) {
        const requestId = ++loadRequestRef.current;
        const { startDate, endDate, displayMonth, displayYear } = getPeriodDates();
        const { month: mStart, year: yStart } = getDayMonthYearByStringDate(startDate);
        const { month, year } = getDayMonthYearByStringDate(endDate);

        console.log("getDataToMyTitlesReport endDate", endDate);
        console.log("getDataToMyTitlesReport month and year startDate", mStart, yStart)
        console.log("getDataToMyTitlesReport month and year endDate", month, year)

        dispatch(
            allActions.innerLoadActions.setInnerLoad({
                show: true,
                loadMessage: 'Carregando títulos...'
            }));


        if (noValidPeriod) {
            dispatch(allActions.innerLoadActions.setInnerLoad({
                show: true,
                emptyMessage: `Não existe ${periodType === 'semester' ? 'semestre' : 'trimestre'} fechado para ${selectedYear}.`
            }));
            return;
        }

        if (!formattedPortfolioData.months?.[displayYear]?.includes(displayMonth)) {
            return;
        }

        const {
            allTitles,
            totalsPublic,
            totalsPrivate,
            totals,
        } = await getAnaliticTitlesByPeriod(
            client.id,
            startDate,
            endDate,
            displayMonth,
            displayYear,
            (mStart != month) || (yStart != year),
            regimeId
        );

        if (requestId !== loadRequestRef.current) return;

        if (allTitles && allTitles.length > 0) {
            setAllTitles(allTitles);
            //Mantém o setor correspondente à aba atual ao recarregar (não força "Públicos")
            setTitlesToShow(allTitles.filter(el => tabValue === 1 ? el.sector != 'PUBLICO' : el.sector == 'PUBLICO'));
            setTotalsBySector({
                totalsPublic,
                totalsPrivate
            });
            setTotals(totals);

            dispatch(
                allActions.innerLoadActions.setInnerLoad({
                    show: false,
                    loadMessage: 'Carregando títulos...'
                }));

            return
        };

        //Sem títulos no recorte: limpa o que estava na tela para não exibir dados de outra seleção
        if (allTitles) {
            setAllTitles([]);
            setTitlesToShow([]);
            setTotalsBySector(null);
            setTotals(null);
        }

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            emptyMessage: regimeId ? 'Não existem títulos para a segregação selecionada' : 'Não existem títulos'
        }));
    };

    const titleOptions = useMemo(() => {
        if (!allTitles) return [];
        const seen = new Set();
        return allTitles
            .filter(t => t.title_name && !seen.has(t.title_name) && seen.add(t.title_name))
            .map(t => ({ label: t.title_name }));
    }, [allTitles]);

    const distributionData = useMemo(() => {
        if (!allTitles || allTitles.length === 0) return null;

        //Agrupamento por título + vencimento: em privados o vencimento vem do ativo (asset_title_due_date),
        //logo um mesmo title_name pode reunir vencimentos diferentes
        const groupMap = new Map();
        allTitles.forEach(t => {
            const name = t.title_name || 'Desconhecido';
            const dueDate = getDueDateTitle(t) || null;
            const key = name + '|' + (dueDate || '');
            const val = parseFloat(t.balance_now) || 0;

            const group = groupMap.get(key);
            if (group) {
                group.amount += val;
            } else {
                groupMap.set(key, { label: name, dueDate: dueDate, amount: val });
            }
        });

        const groups = Array.from(groupMap.values());
        const total = groups.reduce((acc, g) => acc + g.amount, 0);

        const countByLabel = {};
        groups.forEach(g => countByLabel[g.label] = (countByLabel[g.label] || 0) + 1);

        const tableData = groups.map(({ label, dueDate, amount }, i) => {
            const formatedDueDate = dueDate ? moment.utc(dueDate).format('DD/MM/YYYY') : '-';
            return {
                label,
                dueDate,
                formatedDueDate,
                dueDateSort: dueDate ? moment.utc(dueDate).valueOf() : 0,
                //Quando o mesmo título tem mais de um vencimento, a fatia do gráfico leva a data
                chartLabel: countByLabel[label] > 1 ? label + ' [ ' + formatedDueDate + ' ]' : label,
                amount,
                formatedAmount: applyMaskAmount(amount, true),
                percent: total > 0 ? ((amount / total) * 100).toFixed(2) : '0.00',
                legColor: unoTheme.chartColors[i % unoTheme.chartColors.length],
            }
        });

        const chartData = {
            labels: tableData.map(r => r.chartLabel),
            datasets: [{
                data: tableData.map(r => r.amount),
                backgroundColor: tableData.map(r => r.legColor),
            }],
        };

        return { tableData, chartData, total };
    }, [allTitles]);

    const getDistSortValue = useCallback((row) => {
        switch (distOrderBy) {
            case 'percent':
                return parseFloat(row.percent);
            case 'dueDate':
                return row.dueDateSort;
            default:
                return row.amount;
        }
    }, [distOrderBy]);

    const sortedDistData = useMemo(() => {
        if (!distributionData) return null;
        const sorted = _.orderBy(
            distributionData.tableData,
            [getDistSortValue],
            [distOrder]
        );
        return { ...distributionData, tableData: sorted };
    }, [distributionData, getDistSortValue, distOrder]);

    const sortedTitles = useMemo(() => {
        if (!titlesToShow) return [];
        const filtered = selectedTitleFilter
            ? titlesToShow.filter(t => t.title_name === selectedTitleFilter.label)
            : titlesToShow;
        if (!orderBy) return filtered;

        return _.orderBy(filtered, [orderBy], [order]);
    }, [titlesToShow, orderBy, order, selectedTitleFilter]);

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;
        if (!isActive) {
            return <ArrowDropDown style={{ color: "#ccc" }} />;
        }
        return order === "asc" ? (
            <ArrowDropUp style={{ color: unoTheme.mainColor }} />
        ) : (
            <ArrowDropDown style={{ color: unoTheme.mainColor }} />
        );
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder("asc");
        }
    };

    const handleDistSort = (column) => {
        if (distOrderBy === column) {
            setDistOrder(distOrder === "asc" ? "desc" : "asc");
        } else {
            setDistOrderBy(column);
            setDistOrder("asc");
        }
    };

    const DistSortIcon = ({ column }) => {
        const isActive = distOrderBy === column;
        if (!isActive) return <ArrowDropDown style={{ color: "#ccc" }} />;
        return distOrder === "asc"
            ? <ArrowDropUp style={{ color: unoTheme.mainColor }} />
            : <ArrowDropDown style={{ color: unoTheme.mainColor }} />;
    };

    useEffect(() => {
        if (clientOn && clientOn.client) {
            initializePortfolioMonthsAndYears(clientOn.client);
        }
    }, [clientOn, initializePortfolioMonthsAndYears]);

    //O regime escolhido para o cliente anterior pode não estar habilitado para o novo
    useEffect(() => {
        setSegregationSelected(0);
    }, [clientOn?.client?.id]);

    //O título filtrado pode não existir no recorte da nova segregação
    useEffect(() => {
        setSelectedTitleFilter(null);
    }, [accountRegimeId]);

    useEffect(() => {
        if (clientOn && clientOn.client && selectedMonth && selectedYear) {
            loadTitles(clientOn.client, accountRegimeId);
        }
    }, [clientOn, periodType, selectedMonth, selectedYear, selectedQuarter, selectedSemester, accountRegimeId]);

    const currentSector = useMemo(() => tabValue === 0 ? 'Públicos' : 'Privados', [tabValue]);

    const getCurrentPu = useCallback((row) => {

        row.balance_now = row.balance_now ? parseFloat(row.balance_now) : null;
        row.quota_amount_now = row.quota_amount_now ? parseFloat(row.quota_amount_now) : null;
        return row.balance_now && row.quota_amount_now ?
            applyMaskAmountFreeDecimals(row.balance_now / row.quota_amount_now, null, 4) : applyMaskAmount(0, true)
    }, [])

    function getMonthName(month) {
        const months = [
            'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
            'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
        ];
        return months[month - 1] || '';
    }

    useEffect(() => {
        if (flagDoExcelTitles) {

            if (titlesToShow.length <= 0) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    message: "Nenhum título encontrado para relatório",
                    type: 'error',
                }));
            }

            if (selectedMonth &&
                selectedYear && titlesToShow && titlesToShow.length > 0) {

                doExcelTitles(
                    clientOn.client.label_name + "_TITULOS_" + getMonthName(selectedMonth) + "_" + selectedYear
                    + (accountRegimeId ? "_" + REGIME_SHEET_LABELS[accountRegimeId] : ""),
                    selectedMonth,
                    selectedYear,
                    titlesToShow,
                    totals,
                    currentTabTotal,
                    currentSector,
                    sectorMarkingAverage,
                    globalMarkingAverage
                );
            }
            resetFlag();
        }
    }, [flagDoExcelTitles]);

    function doExcelTitles(titleFile, month, year, titles, totals, currentTabTotal, currentSector, sectorMarkingAverage, globalMarkingAverage) {
        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: "Títulos",
            Author: "UNO",
        }

        const sheetName = "Títulos " + getMonthName(month) + "-" + year;
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push(['Título', 'Vencimento', 'Data Compra', 'Quantidade', 'P.U. Compra', 'P.U. Atual', 'Marcação', 'Valor Compra', 'Valor Atual', 'Retorno (R$)', 'Retorno (%)']);

        titles.forEach(row => {
            ws_data.push([
                row.title_name,
                moment.utc(getDueDateTitle(row)).format('DD/MM/YYYY'),
                moment.utc(row.purchase_date).format('DD/MM/YYYY'),
                row.quantity_purchased,
                row.price_title ? applyMaskAmountFreeDecimals(row.price_title, null, 4) : '-',
                getCurrentPu(row),
                row.marking + (row.pre_tax && row.marking != MARKING_MARKET ? ` (${applyMaskAmount(row.pre_tax)}%)` : ''),
                applyMaskAmount(row.price_title * row.quantity_purchased, true),
                row.balance_now ? applyMaskAmount(parseFloat(row.balance_now), true) : applyMaskAmount(0, true),
                applyMaskAmount(row.rentMoneyPeriod, true),
                applyMaskAmount(row.rentPeriod) + "%"
            ]);
        });

        if (currentTabTotal) {
            ws_data.push([]);
            ws_data.push(['Total Títulos ' + currentSector, '', '', '', '', '', formatMarkingAverage(sectorMarkingAverage),
            applyMaskAmount(currentTabTotal.purchaseAmount, true),
            applyMaskAmount(currentTabTotal.currentAmount, true),
            applyMaskAmount(currentTabTotal.rentMoneyPeriod, true),
            applyMaskAmount(currentTabTotal.rentPeriod) + "%"
            ]);
        }

        if (totals) {
            ws_data.push(['Total Global', '', '', '', '', '', formatMarkingAverage(globalMarkingAverage),
                applyMaskAmount(totals.purchaseAmount, true),
                applyMaskAmount(totals.currentAmount, true),
                applyMaskAmount(totals.rentMoneyPeriod, true),
                applyMaskAmount(totals.rentPeriod) + "%"
            ]);
        }

        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), titleFile + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    const periodOptions = [
        { value: 'month', label: 'Mensal' },
        { value: 'quarter', label: 'Trimestral' },
        { value: 'semester', label: 'Semestral' },
        { value: 'year', label: 'Anual' }
    ];

    const monthOptions = portfolioMonths.map(month => ({
        value: month.id,
        label: month.name
    }));

    const quarterOptions = availableQuarters.map(quarter => ({
        value: quarter,
        label: `${quarter}º Trimestre`
    }));

    const semesterOptions = availableSemesters.map(semester => ({
        value: semester,
        label: `${semester}º Semestre`
    }));

    const yearOptions = portfolioYears.map(year => ({
        value: year,
        label: year.toString()
    }));

    const noValidPeriod = useMemo(() => {
        if (periodType === 'semester' && !availableSemesters.length) return true;
        if (periodType === 'quarter' && !availableQuarters.length) return true;
        return false;
    }, [periodType, availableSemesters, availableQuarters]);

    useEffect(() => {
        console.log("noValidPeriod: ", noValidPeriod)
    }, [noValidPeriod])

    return (
        <div className={classes.root}>

            <div className={classes.headerSearch}>
                <div className={classes.leftHeader}>

                    <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>

                        <MyTabs
                            value={tabValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChangeTabValue}>

                            <MyTab label="Públicos" />
                            <MyTab label="Privados" />
                            <MyTab label="Distribuição" />

                        </MyTabs>

                    </div>
                </div>
                <div className={classes.rightHeader}>
                    <div className={classes.filterContainer}>
                        {clientOn?.client?.is_cotization_segregation && (
                            <MySelect
                                value={segregationSelected}
                                onChange={(e) => setSegregationSelected(e.target.value)}
                                options={segregationsOptions.map((row, index) => (
                                    <option key={'segregation-selected-titles-' + index} value={row.value}>{row.name}</option>
                                ))}
                                customWidth="200px"
                            />
                        )}
                        {allTitles && allTitles.length > 0 && tabValue !== 2 && (
                            <MyAutoComplete
                                options={titleOptions}
                                autoComplete
                                customWidth={'180px'}
                                value={selectedTitleFilter}
                                onChange={(event, newValue) => setSelectedTitleFilter(newValue)}
                                label="Título"
                                getOptionLabel={(option) => option.label}
                                getOptionSelected={(option, value) => option.label === value.label}
                                renderOption={(option) => (
                                    <React.Fragment key={'autocomplete-title-' + option.label}>
                                        <span>{option.label}</span>
                                    </React.Fragment>
                                )}
                            />
                        )}
                        <MySelect
                            value={periodType}
                            onChange={(e) => setPeriodType(e.target.value)}
                            options={periodOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                            customWidth="130px"
                        />

                        {(periodType === 'month' || periodType === 'year') && (
                            <MySelect
                                value={selectedMonth || ''}
                                onChange={(e) => setSelectedMonth(Number(e.target.value))}
                                options={monthOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="140px"
                            />
                        )}

                        {periodType === 'quarter' && availableQuarters.length > 0 && (
                            <MySelect
                                value={selectedQuarter}
                                onChange={(e) => setSelectedQuarter(Number(e.target.value))}
                                options={quarterOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="180px"
                            />
                        )}

                        {periodType === 'semester' && availableSemesters.length > 0 && (
                            <MySelect
                                value={selectedSemester}
                                onChange={(e) => setSelectedSemester(Number(e.target.value))}
                                options={semesterOptions.map(opt => (
                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                ))}
                                customWidth="160px"
                            />
                        )}

                        <MySelect
                            value={selectedYear || ''}
                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                            options={yearOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                            customWidth="100px"
                        />
                    </div>
                    {
                        allTitles ?
                            <>
                                <UnoButton
                                    style={{ marginLeft: '8px' }}
                                    size='small'
                                    onClick={() => setFlagDoExcelTitles(true)}
                                    type='success'
                                    startIcon={<PrintIcon />}
                                >
                                    {"Excel"}
                                </UnoButton>
                            </>
                            : null
                    }

                    {allTitles &&
                        <UnoButton
                            isIconButton
                            onClick={() => {
                                const { startDate, endDate } = getPeriodDates();

                                dispatch(allActions.reportLoadActions.setReportLoad({
                                    show: true,
                                    reportType: 'myTitles',
                                    message: 'Gerando o relatório...',
                                    startDate: startDate,
                                    endDate: endDate,
                                    periodType: periodType,
                                    selectedMonth: selectedMonth,
                                    selectedYear: selectedYear,
                                    selectedQuarter: selectedQuarter,
                                    selectedSemester: selectedSemester,
                                    clientId: clientOn?.client?.id,
                                    accountRegimeId: accountRegimeId,
                                    regimeLabel: accountRegimeId ? getRegimeLabel(accountRegimeId) : null,
                                }))
                            }}
                            size='small'
                            type='primary'
                        />
                    }

                </div>
            </div>

            <div class={'defaultScrollWithHeaderContent'}>
                {tabValue === 2 ? (
                    allTitles && sortedDistData ? (
                        <div className={classes.distributionMain}>
                            <div className={classes.distDivTable}>
                                <MyTable stickyHeader size="small">
                                    <colgroup>
                                        <col />
                                        <col width="18%" />
                                        <col width="16%" />
                                        <col width="24%" />
                                        <col width="8%" />
                                    </colgroup>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="left">Título</TableCell>
                                            <TableCell align="center" onClick={() => handleDistSort('dueDate')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    Vencimento <DistSortIcon column="dueDate" />
                                                </div>
                                            </TableCell>
                                            <TableCell align="center" onClick={() => handleDistSort('percent')} style={{ cursor: 'pointer' }}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    Percentual <DistSortIcon column="percent" />
                                                </div>
                                            </TableCell>
                                            <TableCell align="right" onClick={() => handleDistSort('amount')} style={{ cursor: 'pointer' }}>
                                                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                                    Valor Atual <DistSortIcon column="amount" />
                                                </div>
                                            </TableCell>
                                            <TableCell align="center" style={{ minWidth: 60 }}>Leg.</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortedDistData.tableData.map((row, index) => (
                                            <TableRow key={'dist-row-' + index}>
                                                <TableCell align="left">{row.label}</TableCell>
                                                <TableCell align="center">{row.formatedDueDate}</TableCell>
                                                <TableCell align="center">{row.percent}%</TableCell>
                                                <TableCell align="right" className={classes.green}>{row.formatedAmount}</TableCell>
                                                <TableCell align="center">
                                                    <div className={classes.distLegendTable} style={{ background: row.legColor }} />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    {sortedDistData.tableData.length > 0 && (
                                        <TableFooter className={classes.distTableFooter}>
                                            <TableRow key="dist-footer-total">
                                                <TableCell align="left">Total</TableCell>
                                                <TableCell align="center" />
                                                <TableCell align="center"><span className="spanTotal">100%</span></TableCell>
                                                <TableCell align="right"><span className="spanTotal">{applyMaskAmount(sortedDistData.total, true)}</span></TableCell>
                                                <TableCell align="center" />
                                            </TableRow>
                                        </TableFooter>
                                    )}
                                </MyTable>
                            </div>
                            <div className={classes.distDivChart}>
                                <Pie
                                    data={sortedDistData.chartData}
                                    options={{
                                        legend: { display: false },
                                        tooltips: {
                                            callbacks: {
                                                label: (tooltipItem, data) =>
                                                    ' ' + data.labels[tooltipItem.index] + ': ' + applyMaskAmount(data.datasets[0].data[tooltipItem.index], true)
                                            }
                                        }
                                    }}
                                    redraw={true}
                                />
                            </div>
                        </div>
                    ) : (
                        <MyInnerLoad message={'Carregando títulos...'} />
                    )
                ) : (
                    (allTitles && !noValidPeriod) ?
                        <MyTable
                            stickyHeader
                            size="small">
                            <colgroup>
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col />
                                <col width="13%" />
                                <col width="13%" />
                                <col width="17%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="left">Título</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center" onClick={() => handleSort(tabValue != 1 ? "due_date" : "asset_title_due_date")}>
                                        <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                            Venc. <SortIcon column={tabValue != 1 ? "due_date" : "asset_title_due_date"} />
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center" onClick={() => handleSort("purchase_date")}>
                                        <div style={{ display: 'flex', justifyContent: "center", alignItems: 'center', }}>
                                            Compra <SortIcon column="purchase_date" />
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">Qtd</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="right">P.U. Compra</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="right">P.U. Atual</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="center">Marcação</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="right">Valor Compra</TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="right" onClick={() => handleSort("balance_now")}>
                                        <div style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'center', }}>
                                            Valor Atual <SortIcon column="balance_now" />
                                        </div>
                                    </TableCell>
                                    <TableCell style={{ whiteSpace: 'nowrap' }} align="right" onClick={() => handleSort("rentMoneyPeriod")}>
                                        <div style={{ display: 'flex', justifyContent: "flex-end", alignItems: 'center', }}>
                                            Retorno <SortIcon column="rentMoneyPeriod" />
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {sortedTitles.map((row, index) => (
                                    <TableRow key={'title-analisys-' + index} className={classes.smallTextsCells}>
                                        <TableCell align="left">{row.title_name}</TableCell>
                                        <TableCell align="center">{moment.utc(getDueDateTitle(row)).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="center">{moment.utc(row.purchase_date).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell align="center">{row.quantity_purchased}</TableCell>
                                        <TableCell align="right">{row.price_title ? applyMaskAmountFreeDecimals(row.price_title, null, 4) : '-'}</TableCell>
                                        <TableCell align="right">{getCurrentPu(row)}</TableCell>
                                        <TableCell align="center">{
                                            <>
                                                <p style={{ margin: '0px' }}>{row.marking}</p>
                                                <p style={{ margin: '0px' }}>{(row.pre_tax && row.marking != MARKING_MARKET ? applyMaskAmount(row.pre_tax) + "%" : '')}</p>
                                            </>
                                        }</TableCell>
                                        <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>{
                                            applyMaskAmount(row.price_title * row.quantity_purchased, true)}
                                        </TableCell>
                                        <TableCell align="right" className={classes.green}>{row.balance_now ? applyMaskAmount(parseFloat(row.balance_now), true) : applyMaskAmount(0, true)}</TableCell>
                                        <TableCell align="right" style={{ whiteSpace: 'nowrap' }}>{applyMaskAmount(row.rentMoneyPeriod, true) + " ( " + applyMaskAmount(row.rentPeriod) + "%" + " )"}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>

                            {
                                totals && currentTabTotal ?
                                    <TableFooter className={classes.myTableFooter}>
                                        <TableRow key='footer-t-titles-sector-analysis-total' className="totalLineInvestiments">
                                            <TableCell align="left">Total Títulos {currentSector}</TableCell>
                                            <TableCell align="left"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"><span className={'spanTotal'}>{formatMarkingAverage(sectorMarkingAverage)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(currentTabTotal.purchaseAmount, true)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(currentTabTotal.currentAmount, true)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(currentTabTotal.rentMoneyPeriod, true) + " ( " + applyMaskAmount(currentTabTotal.rentPeriod) + "% )"}</span></TableCell>
                                        </TableRow>
                                        <TableRow className='totalLinePL' key={'footer-t-titles-analisys-total'}>
                                            <TableCell align="left">Total Global</TableCell>
                                            <TableCell align="left"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"></TableCell>
                                            <TableCell align="center"><span className={'spanTotal'}>{formatMarkingAverage(globalMarkingAverage)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(totals.purchaseAmount, true)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(totals.currentAmount, true)}</span></TableCell>
                                            <TableCell align="right"><span className={'spanTotal'}>{applyMaskAmount(totals.rentMoneyPeriod, true) + " ( " + applyMaskAmount(totals.rentPeriod) + "% )"}</span></TableCell>
                                        </TableRow>
                                    </TableFooter> : null
                            }
                        </MyTable>
                        :
                        <>
                            <MyInnerLoad message={'Carregando títulos...'} />
                        </>
                )}

            </div>


        </div >
    );
}



